import "./profile.css"
import '../MainFrame.css'

import perfil from '../../../assets/iconos/usuario.png'
import pen from '../../../assets/iconos/pen.png'
import { useEffect, useState } from "react";
import { updateUserData, refreshToken, updateUserPassword, logOut } from '../../../Services/User.js';
import CropImg from "./CropImg/CropImg";
import DialogModal from "../../Modals/dialogModal";



export default function Profile(props) {

    const [idEditing, setIsEditing] = useState(false);
    const [formElements, setFormElements] = useState({});
    const [isEditingPassword, setIsEdittingPassword] = useState(false);
    const [passwordForm, setPasswordForm] = useState({});
    const [showAvatars, setShowAvatars] = useState(false);
    const [avatarList, setAvatarList] = useState([]);

    const [imgToCrop, setImgToCrop] = useState([]);
    const [cropping, setCropping] = useState(false);


    const handlerSubmit = async () => {
        if (!formElements.name || !formElements.email) {
            setModalMsg("Complete los campos de email y nombre.");
            setShowModal(true);
            return;
        }

        let rsp = await updateUserData(formElements);

        if (rsp?.Error == false) {
            setShowSuccessModal(true);
        }
    }

    const handlerPasswordChange = async () => {

        let rsp = await updateUserPassword(passwordForm);


        if (rsp?.Error === false) {
            setShowModal(true);
            setModalMsg(rsp.Message || 'La contraseña fue actualizada correctamente.')
        } else {
            setShowModal(true);
            setModalMsg(rsp.Message || 'En este momento no se pudo actualizar la contraseña');
        }

    }

    const loadAvatars = () => {
        var avatars = [];
        for (let i = 0; i < 42; i++) {
            let src = `avatar/${i + 1}.png`
            avatars[i] = src;
        }
        setAvatarList(avatars);
    }

    useEffect(() => {
        loadAvatars();
    }, [])

    function handleCancelEditing() {
        setIsEditing(!idEditing)
        setShowAvatars(false)
    }

    const handlerSelectFile = () => {
        document.getElementById('imgInput').click();
    }

    const handleSelectImage = (e) => {
        e.preventDefault();

        const file = e.target.files[0];
        e.target.value = null;

        if (!file.type.includes("jpg") && !file.type.includes("jpeg")) {
            setModalMsg("Por favor cargue un archivo de imagen JPG/JPEG.")
            setShowModal(true);
            return;
        }

        setImgToCrop(URL.createObjectURL(file));
        setCropping(true)
    }


    const [showModal, setShowModal] = useState(false);
    const [modalMsg, setModalMsg] = useState("");

    const [showSuccessModal, setShowSuccessModal] = useState(false);

    return (
        <div className='profile-frame'>
            <DialogModal showModal={showModal} setShowModal={setShowModal} >
                <h3>{modalMsg}</h3>
            </DialogModal>
            <div className='profile-header'>
                <div className="profileinfo">
                    {
                        idEditing ?
                        <>
                        <div className="profilepic-cointainer">
                            <img src={formElements?.url_profile_pic || perfil} alt="profilepic" className='profile-big'/>
                            <div className="pencil-container change-avatar">
                                <img src={pen} alt="profilepic" className='profile-edit ' onClick={handlerSelectFile} /> {/*onClick={() => setShowAvatars(!showAvatars)}/>*/}
                            </div>
                            <input type="file" accept="image/jpeg" style={{display:'none'}} id='imgInput' onChange={handleSelectImage} />
                            {
                                cropping ?
                                <CropImg showModal={cropping} setShowModal={setCropping} src={imgToCrop} setImgSrc={setImgToCrop} />
                                :
                                <></>
                            }
                        </div>
                        <div className="usrBasicInfo">
                            <div className="usrBasicInforSubDiv inputBox">
                                <h2 className="userBasicInfoSubElementTitle">Nombres:</h2><input type="text" className="newUserName" onChange={e => setFormElements({...formElements, name: e.target.value})}/>
                            </div>
                            <div className="usrBasicInforSubDiv">
                                <h4 className="userBasicInfoSubElementTitle">E-Mail:</h4><input className="newEmailUser" type="text" onChange={e => setFormElements({...formElements, email: e.target.value})}/>                            
                            </div>
                        </div>                    
                        </>
                        :
                        isEditingPassword ?
                        <>
                            <img src={props.usrData.profilePic || perfil} alt="profilepic" className='profile-big'/>
                            <div className="usrBasicInfo">
                            <h1>{props.usrData.name}</h1>
                            <div className="usrBasicInforSubDiv2">
                                <h4>Actual:&nbsp;&nbsp;</h4> <input type="password" onChange={e => setPasswordForm({...passwordForm, password: e.target.value})}/>
                            </div>
                            <div className="usrBasicInforSubDiv2">
                                <h4>Nueva:&nbsp;&nbsp;</h4> <input type="password" onChange={e => setPasswordForm({...passwordForm, newPassword: e.target.value})}/>
                            </div>
                        </div>

                                </>
                                :
                                <>
                                    <div className="profilepic-container">
                                        <img src={props.usrData.profilePic || perfil} alt="profilepic" className='profile-big' />
                                    </div>
                                    <div className="usrBasicInfo">
                                        <h1>{props.usrData.name}</h1>
                                        <div className="usrBasicInforSubDiv2">
                                            <h4 className="userBasicInfoSubElementTitle">DNI:</h4><h5>{props.usrData.dni}</h5>
                                        </div>
                                        <div className="usrBasicInforSubDiv2">
                                            <h4 className="userBasicInfoSubElementTitle">E-Mail:</h4><h5>{props.usrData.email}</h5>
                                        </div>
                                    </div>
                                </>
                    }
                </div>
                {
                    idEditing ?
                        <div className="edit-controls-user">
                            <button style={{ height: "1.5em" }} onClick={() => handlerSubmit()} className='profile-options green-btn black-on-w setpointer sethoverdark'>Aplicar</button>
                            <button style={{ height: "1.5em" }} onClick={() => handleCancelEditing()} className='profile-options green-btn black-on-w setpointer sethoverdark'>Cancelar</button>
                        </div>
                        :
                        isEditingPassword ?
                            <div className="edit-controls-user">
                                <button style={{ height: "1.5em" }} onClick={() => handlerPasswordChange()} className='profile-options green-btn black-on-w setpointer sethoverdark'>Aplicar</button>
                                <button style={{ height: "1.5em" }} onClick={() => setIsEdittingPassword(!isEditingPassword)} className='profile-options green-btn black-on-w setpointer sethoverdark'>Cancelar</button>
                            </div>
                            :
                            <div className="edit-controls-user">
                                <button className='profile-options green-btn black-on-w setpointer sethoverdark' onClick={() => setIsEditing(!idEditing)}>Editar perfil</button>
                                <button className='profile-options green-btn black-on-w setpointer sethoverdark' onClick={() => setIsEdittingPassword(!isEditingPassword)}>Cambiar Contraseña</button>
                            </div>
                }
            </div>
            <div className="icons-container">
                {
                    showAvatars ?
                        avatarList.map((item, index) => {
                            return (

                                <img src={item} key={index} className='profile-big change-avatar' onClick={() => setFormElements({ ...formElements, url_profile_pic: item })} />

                            )
                        })
                        :
                        <></>
                }
            </div>
            <DialogModal showModal={showSuccessModal} setShowModal={setShowSuccessModal} showClose={false}
                styles={{
                    container: {
                        height: "fit-content"
                    },
                    content: {
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        gap: "6px",
                        justifyContent: "space-between"
                    },
                    icon: {
                        filter: "grayscale(1) contrast(10)"
                    }
                }}
            >
                <h3 style={{ color: "black" }}>Se actualizaron los datos correctamente. Luego de aceptar deber&aacute; volver a ingresar.</h3>
                <button className={'green-btn setpointer'}
                    style={{
                        marginInline: "auto",
                        transition: "filter .7s, background-color 0s",
                        position: "absolute",
                        left: "5%",
                        right: "5%",
                        bottom: 0,
                    }}
                    onClick={() => {logOut(); window.location.reload();}}>Aceptar</button>
            </DialogModal>
        </div>
    );
} 